import axios from 'axios';
import Vue from 'vue'

export default {

    getCampaignReport(campaignId){
        return axios.get('/api/reporting/campaignReport', {params :{campaignId:campaignId}}  )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getScanPerDay(page, campaignId, pageSize){
        return axios.get('/api/reporting/scanPerDay', {params :{page:page, campaignId:campaignId, pageSize:pageSize}}  )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCollectingDataPerDay(page, campaignId, pageSize){
        return axios.get('/api/reporting/collectingDataPerDay', {params :{page:page, campaignId:campaignId, pageSize:pageSize}}  )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getTotalTurnover(month,year,isMonthly,isYearly,type){
        return axios.get('/api/reporting/turnover', { params: { month: month, year:year, isMonthly:isMonthly,isYearly:isYearly,type:type } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPurchasesByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSalesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getQuantityByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalQuantitiesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItems(page, pageSize,start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/topItems',{params: {page: page, pageSize: pageSize,start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTracking(page, pageSize,start,end,customerId,campaignId){
        return axios.get('/api/reporting/tracking',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, campaignId:campaignId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getTotalSales(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSales',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersStatus(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/ordersStatus',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesStatus(countryId,cityId,customerId){
        return axios.get('/api/reporting/invoicesStatus',{params: {countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAccessHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/accessHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSyncHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/syncHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastSynchronisationAccess(){
        return axios.get('/api/reporting/lastSynchronisationAccess')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistoryChartCustomerList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/customer/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSearchHistoryChartSupplierList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/supplier/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
     },

    getOrderHistory(page, pageSize,start,end,customerId){

        return axios.get('/api/reporting/orderHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })

        .then(response => {

            if (response && response.data) return response.data

        })

        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getClaims(page, pageSize,start,end,customerId, claimTypeId, onlyOpenClaims){
        return axios.get('/api/reporting/claims',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, claimTypeId:claimTypeId, onlyOpenClaims:onlyOpenClaims} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAlerts(page, pageSize,start,end,customerId, alertType){
        return axios.get('/api/reporting/alerts',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, alertType: alertType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    setClaimIsClosed(claimId, isClosed) {

        return axios.post('/api/reporting/claims/close/' + claimId + '/' + isClosed)
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        

    },

    getTurnoverByWeek (type ) {
        return axios.get('/api/reporting/turnover/week' ,{ params: {  type: type}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getTurnoverByMonth (type ) {
        return axios.get('/api/reporting/turnover/month' ,{ params: {  type: type}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getPercentTurnover (type ) {
        return axios.get('/api/reporting/turnover/percent' ,{ params: { type: type}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCustomerLanding (type) {
        return axios.get('/api/reporting/landing/' ,{ params: {  type: type}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPartnerStats (type , year) {
        return axios.get('/api/reporting/partner-stats/' ,{ params: {  type: type , year:year}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPartnerStatsByMonth (type , year) {
        return axios.get('/api/reporting/partner-stats-month/' ,{ params: {  type: type , year:year}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getDeliveredItemByCustomer (type ,itemRef,  itemTitle) {
        return axios.get('/api/reporting/delivered-Item/customer/' ,{ params: {  type: type  ,itemRef:itemRef ,itemTitle:itemTitle }})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportCollectedData (start, end, campaignId, exportedColumn) {
        return axios.get('/api/reporting/export/collected/Data' ,{ params: {start:start,end:end, campaignId:campaignId, exportedColumn:exportedColumn}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCsvGenerated (page, pageSize,campaignId) {
        return axios.get('/api/reporting/csv/generated' ,{ params: {page:page,  pageSize:pageSize, campaignId:campaignId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    downloadCSV(csvGeneratedId){
        const now = new Date();

        return axios({
            url:'/api/reporting/csv/download',
            params: { csvGeneratedId: csvGeneratedId},
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const formattedTimestamp = `${now.getFullYear()}-${String(  now.getMonth() + 1   ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}-${String(      now.getHours()  ).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String( now.getSeconds()).padStart(2, '0')}`;
            link.setAttribute('download', `${formattedTimestamp}.csv`);
            document.body.appendChild(link);
            link.click();
            }).catch(() => {Vue.prototype.$snotify.error("Echec de Téléchargement des Données collecter . Veuillez vérifier si des commandes existent pour cette offre !");});

    },
}